module.exports = __webpack_public_path__ + "img/____bg.265b41e7.jpg";